export default {
  login: "/login",
  authenticate: "/authenticate",
  integrationSuccess: "/integration-success",
};
